import { PageContainer, PageHeader } from "../components/PageHeader";
import MediaGallery from "../components/MediaGallery";
import { useTranslation } from "react-i18next";

/**
 * The Global media library - admin-only, and the top layer of three.
 *
 * Holds what is genuinely shared platform-wide: logos and icons for global
 * catalogue items (radio channels, streaming apps), Nenda's own artwork. Every
 * customer and every location can USE these files; only an admin can change
 * them, and only from here.
 *
 * The other two layers are the customer's shared library and a location's own
 * files. Both live under "Content", scoped by the header - see `WorkspacePage`.
 */
export default function GlobalMediaPage() {
  const { t } = useTranslation("content");
  return (
    <PageContainer>
      <PageHeader
        eyebrow={t("globalMediaPage.eyebrow")}
        title={t("globalMediaPage.title")}
        subtitle={t("globalMediaPage.subtitle")}
      />
      <MediaGallery />
    </PageContainer>
  );
}
